import React from "react";

const CustomAlerts = ({ type, alertMessage }) => {
  return (
    <div
      className={
        type === "success"
          ? "alert alert-success alert-dismissible fade show w-25"
          : "alert alert-danger alert-dismissible fade show w-25"
      }
      style={{ position: "fixed", right: 0, top: "100px", zIndex: "100" }}
      role="alert"
    >
      {alertMessage}
      <button
        type="button"
        className="close ms-5"
        data-bs-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  );
};

export default CustomAlerts;
